export const suppliersEn: Record<string, string> = {
  // Common
  'common.back': 'Back',

  // Supplier list page
  'supplier.list.title': 'Suppliers',
  'supplier.list.subtitle': 'Manage your supplier network',
  'supplier.list.loading': 'Loading suppliers...',
  'supplier.list.deleteConfirm': 'Are you sure you want to delete {name}?',
  'supplier.list.error.title': 'Failed to Load Suppliers',
  'supplier.list.error.description': 'An error occurred while loading suppliers.',
  'supplier.list.empty.title': 'No suppliers found',
  'supplier.list.empty.searchDescription': 'No suppliers match your current search or filters.',
  'supplier.list.empty.defaultDescription': 'Get started by adding your first supplier.',
  'supplier.list.empty.addFirst': 'Add First Supplier',

  // Supplier table columns
  'supplier.table.name': 'Name',
  'supplier.table.contact': 'Contact',
  'supplier.table.leadTime': 'Lead Time',
  'supplier.table.leadTimeValue': '{count} days',
  'supplier.table.products': 'Products',
  'supplier.table.performance': 'Performance',
  'supplier.table.actions': 'Actions',

  // Supplier actions
  'supplier.actions.add': 'Add Supplier',
  'supplier.actions.edit': 'Edit',
  'supplier.actions.delete': 'Delete',

  // Supplier create/edit form
  'supplier.form.createTitle': 'Create Supplier',
  'supplier.form.editTitle': 'Edit Supplier',
  'supplier.form.readOnlyNotice': 'You can view supplier data, but you do not have permission to edit it.',
  'supplier.form.confirmDiscard': 'Discard unsaved supplier changes?',
  'supplier.form.sections.identity': 'Identity',
  'supplier.form.sections.contact': 'Contact',
  'supplier.form.sections.commercial': 'Commercial Terms',
  'supplier.form.sections.operational': 'Operational Settings',
  'supplier.form.sections.notes': 'Notes',
  'supplier.form.fields.name': 'Supplier Name *',
  'supplier.form.fields.legalName': 'Legal Name',
  'supplier.form.fields.supplierCode': 'Supplier Code',
  'supplier.form.fields.registrationNumber': 'Registration Number',
  'supplier.form.fields.contactEmail': 'Contact Email',
  'supplier.form.fields.contactPhone': 'Contact Phone',
  'supplier.form.fields.website': 'Website',
  'supplier.form.fields.address': 'Address',
  'supplier.form.fields.taxId': 'Tax ID',
  'supplier.form.fields.vatId': 'VAT ID',
  'supplier.form.fields.paymentTermsDays': 'Payment Terms (Days)',
  'supplier.form.fields.currencyPreference': 'Preferred Currency',
  'supplier.form.fields.incoterm': 'Incoterm',
  'supplier.form.fields.countryCode': 'Country Code (ISO-2)',
  'supplier.form.fields.region': 'Region / State',
  'supplier.form.fields.leadTimeDays': 'Lead Time (Days)',
  'supplier.form.fields.orderChannelPreference': 'Order Channel Preference',
  'supplier.form.fields.accountManagerProfileId': 'Account Manager Profile ID',
  'supplier.form.fields.status': 'Status',
  'supplier.form.fields.healthStatus': 'Health Status',
  'supplier.form.fields.procurementReady': 'Procurement Ready',
  'supplier.form.fields.procurementReadyHint': 'Marks this supplier ready for procurement workflows.',
  'supplier.form.fields.fulfillmentNotes': 'Fulfillment Notes',
  'supplier.form.fields.notes': 'Internal Notes',
  'supplier.form.status.active': 'Active',
  'supplier.form.status.inactive': 'Inactive',
  'supplier.form.status.blocked': 'Blocked',
  'supplier.form.status.archived': 'Archived',
  'supplier.form.health.none': 'Not set',
  'supplier.form.health.good': 'Good',
  'supplier.form.health.watch': 'Watch',
  'supplier.form.health.risk': 'Risk',
  'supplier.form.health.critical': 'Critical',
  'supplier.form.actions.cancel': 'Cancel',
  'supplier.form.actions.close': 'Close',
  'supplier.form.actions.create': 'Create Supplier',
  'supplier.form.actions.update': 'Save Changes',
  'supplier.form.actions.saving': 'Saving...',
  'supplier.form.validation.nameRequired': 'Supplier name is required.',
  'supplier.form.validation.invalidEmail': 'Enter a valid email address.',
  'supplier.form.validation.invalidWebsite': 'Enter a valid website URL.',
  'supplier.form.validation.invalidCountryCode': 'Country code must contain 2 letters.',
  'supplier.form.validation.invalidCurrencyCode': 'Currency must contain 3 letters.',
  'supplier.form.validation.invalidUuid': 'Enter a valid UUID value.',
  'supplier.form.validation.nonNegative': 'Value must be zero or greater.',
  'supplier.form.messages.authRequired': 'Please sign in again to continue.',
  'supplier.form.messages.saveError': 'Failed to save supplier changes.',

  // Supplier messages
  'supplier.messages.error': 'An error occurred.',
  'supplier.messages.created': 'Supplier created successfully.',
  'supplier.messages.updated': 'Supplier updated successfully.',
  'supplier.messages.deleted': 'Supplier deleted successfully.',
  'supplier.messages.loadProductsError': 'Failed to load products.',
  'supplier.messages.productRemoved': 'Product removed successfully.',
  'supplier.messages.productRemoveError': 'Failed to remove product.',

  // Supplier detail page
  'supplier.detail.notFound.title': 'Supplier Not Found',
  'supplier.detail.notFound.description': 'The supplier you are looking for does not exist or has been removed.',
  'supplier.detail.tabs.profile': 'Profile',
  'supplier.detail.tabs.pricing': 'Pricing',
  'supplier.detail.tabs.products': 'Products',
  'supplier.detail.tabs.pos': 'Purchase Orders',
  'supplier.detail.tabs.performance': 'Performance',
  'supplier.detail.contactInfo': 'Contact Information',
  'supplier.detail.businessDetails': 'Business Details',
  'supplier.detail.taxId': 'Tax ID',
  'supplier.detail.leadTime': '{count} days lead time',
  'supplier.detail.performanceScore': 'Performance Score',
  'supplier.detail.productsCount': 'Products',
  'supplier.detail.notes': 'Notes',

  // Supplier products tab
  'supplier.products.title': 'Supplied Products',
  'supplier.products.loading': 'Loading products...',
  'supplier.products.count': '{count} products',
  'supplier.products.search': 'Search products...',
  'supplier.products.empty.search': 'No products found matching your search.',
  'supplier.products.empty.default': 'No products assigned to this supplier yet.',
  'supplier.products.empty.hint': 'Assign products to this supplier using the Price List tab or the Products page.',
  'supplier.products.table.product': 'Product',
  'supplier.products.table.sku': 'SKU',
  'supplier.products.table.costPrice': 'Cost Price',
  'supplier.products.table.currency': 'Currency',
  'supplier.products.table.actions': 'Actions',

  // Supplier pricing tab
  'supplier.pricing.title': 'Price List',
  'supplier.pricing.addPrice': 'Add Price',
  'supplier.pricing.saving': 'Saving...',
  'supplier.pricing.saveChanges': 'Save Changes',
  'supplier.pricing.empty': 'No prices configured yet.',
  'supplier.pricing.addFirst': 'Add First Price',
  'supplier.pricing.selectProduct': 'Select product...',
  'supplier.pricing.table.product': 'Product',
  'supplier.pricing.table.costPrice': 'Cost Price',
  'supplier.pricing.table.currency': 'Currency',
  'supplier.pricing.messages.loadError': 'Failed to load price data.',
  'supplier.pricing.messages.noValidPrices': 'No valid prices to save.',
  'supplier.pricing.messages.saved': 'Prices saved successfully.',
  'supplier.pricing.messages.saveError': 'Failed to save prices.',

  // Supplier performance tab
  'supplier.performance.title': 'Performance Metrics',
  'supplier.performance.badges.excellent': 'Excellent',
  'supplier.performance.badges.good': 'Good',
  'supplier.performance.badges.fair': 'Fair',
  'supplier.performance.badges.poor': 'Poor',
  'supplier.performance.metrics.onTimeDelivery': 'On-Time Delivery',
  'supplier.performance.metrics.qualityScore': 'Quality Score',
  'supplier.performance.metrics.responseTime': 'Response Time',
  'supplier.performance.ordersOf': '{onTime} of {total} orders',
  'supplier.performance.basedOnFeedback': 'Based on feedback',
  'supplier.performance.averageResponse': 'Average response',
  'supplier.performance.delivery.title': 'Delivery Performance',
  'supplier.performance.delivery.onTime': 'On-time deliveries',
  'supplier.performance.delivery.late': 'Late deliveries',
  'supplier.performance.delivery.avgDelay': 'Average delay (when late)',
  'supplier.performance.delivery.days': '{count} days',
  'supplier.performance.chart.title': 'Historical Performance Chart',
  'supplier.performance.chart.description': 'Interactive charts showing performance trends over time will be available here.',
  'supplier.performance.mockDataNote': 'Performance metrics are currently showing mock data. Actual tracking will be implemented once delivery logging is integrated with the system.',

  // Purchase orders tab (supplier context)
  'po.supplier.noPOs': 'No purchase orders for this supplier.',
  'po.table.number': 'PO Number',
  'po.table.status': 'Status',
  'po.table.expectedDelivery': 'Expected Delivery',
  'po.table.total': 'Total',
  'po.table.createdAt': 'Created',
};
